import { useState, useEffect } from "react"
import { API_CONFIG } from './api.js';
import { Routes, Route, useNavigate} from "react-router-dom";

export default function Dev(){

    const navigate = useNavigate();

    useEffect(()=>{

        async function get_and_redirect(){
            let data = await get_dummy_data()
            navigate('/results', {state: data});
        }
        get_and_redirect()

    }, [])


    return(
        <div>Running Analysis!</div>
    )

}

async function get_dummy_data(){
    
          try {
            const response = await fetch(`${API_CONFIG.baseURL}/get_dummy_data`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',},
            })
            let data = await response.json()
            console.log(data)
            return data
        }

        catch{
            console.log("Error!")
        }
    }